import { Content } from "./SearchContent/ContentResultList/ContentListItem/ContentListItem.types";
import { getData } from "@infrastructure/ClientConsumer";
import ApiService from "@infrastructure/Services/ApiService";

async function fetchSearchResults(
    value: string,
    groupIds: number[],
    excludePostId?: number,
    searchVariant?: string,
    limit?: number,
    ranking?: string,
): Promise<Content[]> {
    const res = await getData<Content[]>(ApiService.COMMUNITY_SEARCH_CONTENT, {
        params: {
            query: value,
            groupIds,
            excludePostId,
            searchVariant,
            limit,
            ranking,
        },
    });
    return res.data;
}

export function emptyQuerySearchResults(
    groupIds: number[],
    excludePostId?: number,
    searchVariant?: string,
    limit?: number,
    ranking?: string,
): Promise<Content[]> {
    return fetchSearchResults(
        "",
        groupIds,
        excludePostId,
        searchVariant,
        limit,
        ranking,
    );
}

export function searchByContent(
    value: string,
    groupIds: number[],
    excludePostId?: number,
    searchVariant?: string,
    limit?: number,
) {
    return fetchSearchResults(
        value,
        groupIds,
        excludePostId,
        searchVariant,
        limit,
    );
}
